import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-057744de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "帮助与反馈", -1))
const _hoisted_3 = { class: "more-info-list" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoreInfoItem = _resolveComponent("MoreInfoItem")!
  const _component_Spin = _resolveComponent("Spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["more-info", {'sl-full': _ctx.isFullScreen}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "javascript:;",
        class: "qh-icon-back",
        title: "返回",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
      }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_MoreInfoItem, {
        title: "在线客服",
        "sub-title": "（8:00～24:00）",
        onClick: _ctx.goCustomerService
      }, null, 8, ["onClick"]),
      _createElementVNode("a", {
        href: `tel:${_ctx.HotlineTelNumber}`
      }, [
        _createVNode(_component_MoreInfoItem, {
          title: "客服热线",
          "sub-title": "（8:00～24:00）",
          onClick: _ctx.goHotline
        }, null, 8, ["onClick"])
      ], 8, _hoisted_4),
      _createVNode(_component_MoreInfoItem, {
        title: "提交工单",
        onClick: _ctx.goSubmit
      }, null, 8, ["onClick"]),
      _createVNode(_component_MoreInfoItem, {
        title: "帮助文档",
        onClick: _ctx.goHelp
      }, null, 8, ["onClick"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Spin, { key: 0 }))
      : _createCommentVNode("", true)
  ], 2))
}